import { render, staticRenderFns } from "./ServiceRequestDetail.vue?vue&type=template&id=1b357378&scoped=true&"
import script from "./ServiceRequestDetail.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestDetail.vue?vue&type=script&lang=js&"
import style0 from "./ServiceRequestDetail.vue?vue&type=style&index=0&id=1b357378&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b357378",
  null
  
)

export default component.exports